import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-right-slideout-panel',
  templateUrl: './right-slideout-panel.component.html',
  styleUrl: './right-slideout-panel.component.scss',
})
export class RightSlideoutPanelComponent {
  constructor(
    public dialogRef: MatDialogRef<RightSlideoutPanelComponent>,
    @Inject(MAT_DIALOG_DATA) public matDialogData: any
  ) {}
}
